import { ROLES } from './constants';

export const enum Permissions {
  addUser,
  updateUser,
  deleteUser,
  manageOrganization,
  manageDevice,
  editDeviceDetail,
  editHardwareInterface,
  manageCellularInterface,
  editUsbInterface,
  manageVlan,
  manageBridge,
  manageActiveHosts,
  manageExportActiveHosts,
  manageTrafficStatistics,
  manageExportTrafficStatistics,
  manageVpn,
  manageIpsec,
  manageQos,
  manageTrafficSteering,
  manageUserGroups,
  manageWanPingDestination,
  manageTunnelBindPingDestination,
  manageSplitDns,
  manageStaticRouting,
  manageDynamicRouting,
  manageSnmp,
  manageDynamicDns,
  manageStaticHosts,
  manageDnat,
  remoteSSH,
  troubleShooting,
  manageSuricataSettings,
  viewSuricataAlerts,
  manageDeviceSettings,
  manageDefaultDomains,
  manageCustomDomains,
  managePrismaServers,
  manageDeviceModel,
  manageBypassList,
  manageForwardSettings,
  manageDnsFiltering,
  manageLogForwarding,
  manageConfigurationSettings,
  manageNotificationSettings,
  manageAlertSettings,
  manageNotifications,
  manageDeleteNotifications,
  manageSla,
  manageExportSla,
  manageStatusSummary,
  manageExportStatusSummary,
}

const basicPermissions = [
  Permissions.manageDevice,
  Permissions.editDeviceDetail,
  Permissions.editHardwareInterface,
  Permissions.manageCellularInterface,
  Permissions.editUsbInterface,
  Permissions.manageVlan,
  Permissions.manageBridge,
  Permissions.manageActiveHosts,
  Permissions.manageTrafficStatistics,
  Permissions.manageVpn,
  Permissions.manageIpsec,
  Permissions.manageQos,
  Permissions.manageTrafficSteering,
  Permissions.manageUserGroups,
  Permissions.manageWanPingDestination,
  Permissions.manageTunnelBindPingDestination,
  Permissions.manageSplitDns,
  Permissions.manageStaticRouting,
  Permissions.manageDynamicRouting,
  Permissions.manageSnmp,
  Permissions.manageDynamicDns,
  Permissions.manageStaticHosts,
  Permissions.manageSuricataSettings,
  Permissions.viewSuricataAlerts,
  Permissions.manageDnat,
  Permissions.manageDnsFiltering,
  Permissions.manageLogForwarding,
  Permissions.manageConfigurationSettings,
  Permissions.manageSla,
];

export const UserPermissions = {
  [ROLES.superAdmin]: [
    ...basicPermissions,
    Permissions.addUser,
    Permissions.updateUser,
    Permissions.deleteUser,
    Permissions.manageOrganization,
    Permissions.manageExportActiveHosts,
    Permissions.manageExportTrafficStatistics,
    Permissions.remoteSSH,
    Permissions.troubleShooting,
    Permissions.manageDeviceSettings,
    Permissions.manageDefaultDomains,
    Permissions.managePrismaServers,
    Permissions.manageDeviceModel,
    Permissions.manageBypassList,
    Permissions.manageForwardSettings,
    Permissions.manageExportSla,
    Permissions.manageStatusSummary,
    Permissions.manageExportStatusSummary,
  ],
  [ROLES.customerAdmin]: [
    ...basicPermissions,
    Permissions.addUser,
    Permissions.manageExportActiveHosts,
    Permissions.manageExportTrafficStatistics,
    Permissions.manageCustomDomains,
    Permissions.manageNotificationSettings,
    Permissions.manageAlertSettings,
    Permissions.manageNotifications,
    Permissions.manageDeleteNotifications,
    Permissions.manageExportSla,
    Permissions.manageExportStatusSummary,
  ],
  [ROLES.readOnlyAdmin]: [
    Permissions.manageExportActiveHosts,
    Permissions.manageExportTrafficStatistics,
    Permissions.manageNotifications,
    Permissions.manageExportSla,
    Permissions.manageExportStatusSummary,
    Permissions.viewSuricataAlerts,
  ],
};
